module.exports = __webpack_public_path__ + "img/Hypoxia-OVCA_10X_TPCP.304d06d3.png";